import { memo, type ReactNode } from 'react';

export type SectionDisplayProps = {
  title: string;
  children: ReactNode;
  'data-testid'?: string;
};

export const SectionDisplay = memo(({ title, children, 'data-testid': dataTestId }: SectionDisplayProps) => {
  return (
    <div className="flex flex-col gap-2" data-testid={dataTestId}>
      <div className="font-bold ads:text-metadata text-10 text-gray-10 uppercase tracking-[0.4px]">{title}</div>
      {children}
    </div>
  );
});

SectionDisplay.displayName = 'SectionDisplay';
